import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from './pages/PageNotFound.vue'
import Home from './pages/Home.vue'
import ProductListPage from './pages/ProductListPage.vue'
import Profile from './pages/Profile.vue'
import PaymentSuccessPage from './pages/PaymentSuccessPage.vue'
import PaymentFaliPage from './pages/PaymentFaliPage.vue'
import TextPage from './pages/TextPage.vue'
import ProductPage from './pages/ProductPage.vue'



Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	routes: [
		//{ path: '/', redirect: '/home' },
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/product-list/:id',
			name: 'ProductListPage',
			component: ProductListPage
		},
		{
			path: '/product/:id',
			name: 'ProductPage',
			component: ProductPage
		},
		{
			path: '/profile/:nav',
			name: 'Profile',
			component: Profile
		},
		{
			path: '/success-payment',
			name: 'PaymentSuccessPage',
			component: PaymentSuccessPage
		},
		{
			path: '/fail-payment',
			name: 'PaymentFaliPage',
			component: PaymentFaliPage
		},
		{
			path: '/pages/:id',
			name: 'TextPage',
			component: TextPage
		},
		{ 
			path: "*", 
			name: 'PageNotFound',
			component: PageNotFound,
			props: {title: "PageNotFound"}
		}
	]
})

